// Korean UI labels — STUB, flagged for translation.
// Empty by design: falls back to English (en.js) per key. Human translation
// only — no machine guesses. Included as a launch stub; like Japanese it also
// proves the layout holds for a non-Latin script. Copy the key structure from
// en.js, translate, then flip `translated: true` for "ko" in i18n/languages.js.
export default {}
